import { ThunkDispatch } from "core-integration/src/store";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { ILoggedInPlayer } from "core-integration/src/store/player/types";
import { getRegionsById } from "core-integration/src/store/regions/reducers";
import { fetchRegions } from "core-integration/src/store/regions/thunks";
import { BasicScoreboard } from "plos/src/components/Scoreboard";
import { scoreboardGrid } from "plos/src/components/Scoreboard/scoreboard.css";
import useScoreboard from "plos/src/components/Scoreboard/useScoreboard";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EditableTeamNamePanel } from "../../PlayerInfoPanel";

const SquadSelectionScoreboard = () => {
  const dispatch = useDispatch<ThunkDispatch>();

  const {
    currencyDivisor,
    elementTypesByPosition,
    proposedElements,
    toSpend,
    isNeedElements,
    isBudgetExceeded,
  } = useScoreboard();

  useEffect(() => {
    dispatch(fetchRegions());
  }, [dispatch]);

  const player = useSelector(getPlayerData) as ILoggedInPlayer;
  const regionsById = useSelector(getRegionsById);
  const region = player.region ? regionsById[player.region] : undefined;

  return (
    <div className={scoreboardGrid}>
      <EditableTeamNamePanel region={region} player={player} />
      <BasicScoreboard
        currencyDivisor={currencyDivisor}
        elementTypesByPosition={elementTypesByPosition}
        isBudgetExceeded={isBudgetExceeded}
        isNeedElements={isNeedElements}
        proposedElements={proposedElements}
        toSpend={toSpend}
      />
    </div>
  );
};

export default SquadSelectionScoreboard;
